import { render, staticRenderFns } from "./CreateNewsfeed.vue?vue&type=template&id=6372a42e&"
import script from "./CreateNewsfeed.vue?vue&type=script&lang=js&"
export * from "./CreateNewsfeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports